import { useDispatch, useSelector } from "react-redux";
import { getAppSetting } from "../store/actions";
import { appLoc } from "core/utils/helper";
import { regions } from "core/utils/region";

export const useFetchAppSetting = () => {
  const dispatch = useDispatch();
  const _handleAppSetting = () => {
    //console.log('useFetchAppSetting ');
    
    dispatch(getAppSetting({}));
  };

  return _handleAppSetting;
}


export const useAppSetting = () => {
  const appSettings = useSelector((state: any) => state.AppSettings?.data || []);
  const _appSettings:any = {...appSettings, region: regions[appLoc()]};

  return _appSettings;
}
